/**
 * A patient's display name from its name parts.
 *
 * `surName` is optional on the patient record, and a part can arrive as a
 * literal "null"/"undefined" string when it was serialised from a missing
 * value. Joining the parts with a template literal then reads "Ali null" or
 * just "null", so missing and placeholder parts are dropped instead, with a
 * readable fallback when nothing usable is left.
 */
export function patientDisplayName(
  patient:
    | {
        firstName?: string | null;
        surName?: string | null;
      }
    | null
    | undefined,
  fallback = 'Unnamed patient',
): string {
  const parts = [patient?.firstName, patient?.surName]
    .map((part) => (typeof part === 'string' ? part.trim() : ''))
    .filter(
      (part) =>
        part !== '' &&
        part.toLowerCase() !== 'null' &&
        part.toLowerCase() !== 'undefined',
    );
  return parts.length ? parts.join(' ') : fallback;
}
